import Utils from '../utils';
import Typograf from 'typograf';
const tp = new Typograf({locale: ['ru', 'en-US']});

import { textYears } from "../../scripts/helpers";

export {
    formatPhone,
    formatMoneyToInt,
    formatPercent,
	formatMoney,
	periodString,
	years,
	declineScore,
	declineAtms,
	typograf,
	formatWithDelimeters,
}

export default {
	formatMoney: formatMoney,

	formatMoneyWithCurrency: formatMoneyWithCurrency,

	formatMoneyToInt: formatMoneyToInt,

	formatInt: formatInt,

	// prettyInt: prettyInt,

	formatPercent: formatPercent,

	formatPhone: formatPhone,

	typograf: typograf,

	periodString: periodString,

	declineCards: declineCards,

	declineHours: declineHours,

	declineDays: declineDays,

	declineAtms: declineAtms,

    declineYears: declineYears,

    declineScore: declineScore
}

function formatMoney(value, currency) {
	value = Utils.format(value);
	value = Utils.float(value);
	value = value.toFixed(2);
	value = formatWithDelimeters(value);
	value = value.replace('.00', '');
	value = value.replace('.', ',');
	return formatMoneyWithCurrency(value, currency);
}

// function prettyInt(value) {
// 	value = Utils.format(value);
// 	value = Utils.float(value);
// 	value = value.toFixed(2);
// 	value = formatWithDelimeters(value);
// 	value = value.replace('.00', '');
// 	value = value.replace('.', ',');
// 	return value;
// }

function formatWithDelimeters(value) {
	var newValue, base, decimal, firstPartLength,
		delimeter = ' ';

	if (!value) return

	newValue = value.toString();
	if (newValue.length > 3) {
		base = newValue.split('.')[0];
		if (base.length > 3) {
			decimal = newValue.split('.')[1] || '';
			firstPartLength = base.length % 3;
			newValue = ((firstPartLength) ? base.substr(0, firstPartLength) + delimeter : '') + base.substr(firstPartLength).replace(/(\d{3})(?=\d)/g, "$1" + delimeter)
				+ ((decimal) ? '.' + decimal : '');
		}
	}
	return newValue;
}

function formatMoneyWithCurrency(value, currency) {
	if (currency === false) {
		return value;
	}
	if (currency == undefined || typeof currency !== 'object' || !('sign' in currency) || !('signPosition' in currency)) {
		currency = {sign: '₽', signPosition: 'after'};
	}

	if (currency.signPosition === 'before') {
		return currency.sign + ' ' + value;
	} else {
		return value + ' ' + currency.sign;
	}
}

function formatMoneyToInt(value, currency) {
	value = Utils.format(value);
	value = Utils.float(value);
	value = Math.round(value);
	value = formatWithDelimeters(value);
	return formatMoneyWithCurrency(value, currency);
}

function formatInt(value) {
	value = Utils.format(value);
	value = Utils.float(value);
	value = Math.round(value);
	//value = formatWithDelimeters(value);
	return value;
}

function formatPercent(value) {
	value = Utils.float(Utils.format(value));
	value = Math.round(value * 100) / 100;
	value = value.toString().replace('.', ',');
	return value + '%';
}

function formatPhone(value) {
	return value.substr(0, 1) + ' '
		+ value.substr(1, 3) + ' '
		+ value.substr(4, 3) + '-'
		+ value.substr(7, 2) + '-'
		+ value.substr(9);
}

function typograf(value) {
	return tp.execute(value);
}

function periodString(value) {
	var years = ['год', 'года', 'лет'];
	var cases = [2, 0, 1, 1, 1, 2];
	return value + ' ' + years[(value%100>4 && value%100<20)? 2 : cases[(value%10<5)?value%10:5]];
}

function declineCards(value) {
	const words = ['карта', 'карты', 'карт'];
	const cases = [2, 0, 1, 1, 1, 2];

	return `${value} ${words[(value % 100 > 4 && value % 100 < 20)
		? 2
		: cases[(value % 10 < 5)
			? value % 10
			: 5]]}`;
}

function declineHours(value) {
	const words = ['час', 'часа', 'часов'];
	const cases = [2, 0, 1, 1, 1, 2];

	return `${value} ${words[(value % 100 > 4 && value % 100 < 20)
		? 2
		: cases[(value % 10 < 5)
			? value % 10
			: 5]]}`;
}

function declineDays(value) {
	const words = ['день', 'дня', 'дней'];
	const cases = [2, 0, 1, 1, 1, 2];

	return `${value} ${words[(value % 100 > 4 && value % 100 < 20)
		? 2
		: cases[(value % 10 < 5)
			? value % 10
			: 5]]}`;
}

function declineYears(value) {
	const words = ['год', 'года', 'лет'];
	const cases = [2, 0, 1, 1, 1, 2];

	return `${value} ${words[(value % 100 > 4 && value % 100 < 20)
		? 2
		: cases[(value % 10 < 5)
			? value % 10
			: 5]]}`;
}

function declineAtms(value) {
	const words = ['банкомат', 'банкомата', 'банкоматов'];
	const cases = [2, 0, 1, 1, 1, 2];

	return `${value} ${words[(value % 100 > 4 && value % 100 < 20)
		? 2
		: cases[(value % 10 < 5)
			? value % 10
			: 5]]}`;
}

function declineScore (value) {
	const words = ['балл', 'балла', 'баллов'];
	const cases = [2, 0, 1, 1, 1, 2];

	return `${value} ${words[(value % 100 > 4 && value % 100 < 20)
		? 2
		: cases[(value % 10 < 5)
			? value % 10
			: 5]]}`;
}

function years(val) {
	return val + ' ' + textYears()(parseInt(val, 10));
}
